module.exports = __webpack_public_path__ + "static/media/shang.a497b386.png";